import { Injectable } from '@angular/core';
import { ConfirmationPopupButton, IConfirmationPopupComponentFlags } from './interfaces';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationPopupService {
  setButtonFlags(flags: IConfirmationPopupComponentFlags, buttons?: ConfirmationPopupButton[]): void {
    flags.showCancelButton = false;
    flags.showNoButton = false;
    flags.showOkButton = false;
    flags.showYesButton = false;

    if (!buttons || buttons.length === 0) {
      flags.showOkButton = true;
      return;
    }

    for (let button of buttons) {
      if (button === ConfirmationPopupButton.cancel) {
        flags.showCancelButton = true;
      }
      if (button === ConfirmationPopupButton.no) {
        flags.showNoButton = true;
      }
      if (button === ConfirmationPopupButton.ok) {
        flags.showOkButton = true;
      }
      if (button === ConfirmationPopupButton.yes) {
        flags.showYesButton = true;
      }
    }
    if (!flags.showCancelButton && !flags.showNoButton && !flags.showOkButton && !flags.showYesButton) {
      // If none of the buttons is specified, show the OK button only
      flags.showOkButton = true;
    }
  }
}
